import { lazy, useEffect, useState } from 'react'
import { Loader, NVButton, Select } from '@nv/basic-components'
import { useNVModal } from '@nv/components'
import { AdminVoterService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './AdminVbmBarcodeScan.module.scss'

const BarcodeScannerUSB = lazy(() => import('@nv/lazy-loadable/lib/modals/BarcodeScannerUSB'))

export const AdminVbmBarcodeScan = () => {
  const { t, i18n } = useTranslation()
  const [scannedBarcodes, setScannedBarcodes] = useState([])
  const navigate = useNavigate()
  const [updateType, setUpdateType] = useState('')
  const [scanType, setScanType] = useState('')
  const [loading, setLoading] = useState(false)
  const [scanResults, setScanResults] = useState({
    complete: false,
    errorUpdateIds: [],
    successUpdateIds: [],
  })

  const {
    NVModal: BarcodeScannerModal,
    openModal: openBarcodeScannerModal,
    isModalOpen: isBarcodeScannerModalOpen,
    closeModal: closeBarcodeScannerModal,
  } = useNVModal()

  const onClickUpdateAll = async () => {
    if (scanType === 'bulk' && updateType && scannedBarcodes.length) {
      setLoading(true)
      const resp = await AdminVoterService.updateVoteByMailBallotStatusBulk(scannedBarcodes, updateType)
      setLoading(false)
      if (resp.success) {
        if (resp.errorUpdateIds?.length === scannedBarcodes.length) {
          alert('All updates failed. Make sure you have selected the correct update type.')
        } else {
          setScanResults({
            complete: true,
            errorUpdateIds: resp.errorUpdateIds,
            successUpdateIds: resp.successUpdateIds,
          })
        }
      }
    }
  }

  useEffect(() => {
    openBarcodeScannerModal()
  }, [])

  useEffect(() => {
    if (scanType === 'single' && scannedBarcodes.length) {
      navigate(`/admin/elector-details/${scannedBarcodes[0]}`)
    }
  }, [scannedBarcodes])

  useEffect(() => {
    if (!isBarcodeScannerModalOpen) {
      setScanResults({
        complete: false,
        errorUpdateIds: [],
        successUpdateIds: [],
      })
      setScannedBarcodes([])
      setUpdateType('')
      setScanType('')
      setLoading(false)
    }
  }, [isBarcodeScannerModalOpen])

  return (
    <>
      <BarcodeScannerModal>
        {loading ? (
          <Loader />
        ) : scanResults.complete ? (
          <div>
            <h2> Failed Barcodes ({scanResults.errorUpdateIds.length}):</h2>
            {scanResults.errorUpdateIds.map((b, index) => (
              <div key={index}>{b}</div>
            ))}
            <br />
            <br />
            <h2> Successfully Updated Barcodes ({scanResults.successUpdateIds.length}):</h2>
            {scanResults.successUpdateIds.map((b, index) => (
              <div key={index}>{b}</div>
            ))}
            <br />
            <div
              style={{
                alignSelf: 'flex-end',
                justifySelf: 'flex-end',
              }}
            >
              <NVButton variant='primary' text={t('buttons.ok')} height={50} onClick={closeBarcodeScannerModal} />
            </div>
          </div>
        ) : (
          <>
            <Select
              label={'Scan Type: '}
              options={[
                { value: 'bulk', label: 'Bulk' },
                { value: 'single', label: 'Single' },
              ]}
              isRequired={true}
              value={scanType}
              onChange={(val) => {
                setScanType(val.value)
              }}
            />
            {scanType === 'bulk' ? (
              <div>
                <br />
                <Select
                  label={'Update Type: '}
                  options={[
                    { value: 'Ready', label: 'Ballot Package Ready' },
                    { value: 'Received', label: 'Received' },
                  ]}
                  isRequired={true}
                  value={updateType}
                  onChange={(val) => {
                    setUpdateType(val.value)
                  }}
                />
                <br />
                {scannedBarcodes.length > 50 ? null : (
                  <BarcodeScannerUSB scannedBarcodes={scannedBarcodes} setScannedBarcodes={setScannedBarcodes} />
                )}
                <br />
                <h2>
                  {' '}
                  Scanned Barcodes: <span>{scannedBarcodes.length}</span>
                  <span>/50</span>
                </h2>
                {scannedBarcodes.map((b, index) => (
                  <div key={index}>{b}</div>
                ))}
                <br />
                <br />
                <div
                  style={{
                    alignSelf: 'flex-end',
                    justifySelf: 'flex-end',
                  }}
                >
                  <NVButton variant='primary' text={t('Update All')} height={50} onClick={onClickUpdateAll} />
                </div>
              </div>
            ) : scanType === 'single' ? (
              <>
                <BarcodeScannerUSB scannedBarcodes={scannedBarcodes} setScannedBarcodes={setScannedBarcodes} />
              </>
            ) : null}
          </>
        )}
      </BarcodeScannerModal>
      <div className={styles['container']}>
        <div style={{ marginLeft: 200, marginTop: 100 }}>
          <NVButton text='Scan Barcode' onClick={() => openBarcodeScannerModal()} />
        </div>
      </div>
    </>
  )
}
